// extracted by mini-css-extract-plugin
export default {"submitBtn":"IssueForm_submitBtn__tK2hI","radioGroup":"IssueForm_radioGroup__VTSJN","similar":"IssueForm_similar__jGePO"};